import { cn } from "@/helper/HelperFunction";
import PropTypes from "prop-types";
import { forwardRef } from "react";
import classes from "./button.module.css";

export const Button = forwardRef(
  (
    {
      parent,
      label,
      customStyle,
      secondaryButton,
      onClick,
      disabled,
      children,
      className,
      leftIcon,
      rightIcon,
      width,
      background,
      color,
      variant = "primary",
      size = "sm",
      type = "square",
      isHover,
      isSimpleHover,
      iconColor = "var(--white-color)",
      ...props
    },
    ref
  ) => {
    return (
      <>
        <button
          className={cn(
            classes.btn,
            secondaryButton && classes.secondaryBtn,
            isHover && classes.hover,
            isSimpleHover && classes.isSimpleHover,
            disabled && classes.disabled,
            className && className
          )}
          style={customStyle && customStyle}
          onClick={onClick}
          disabled={disabled ? disabled : false}
          data-variant={variant}
          data-type={type}
          data-size={size}
          {...props}
          ref={ref}
        >
          {/* {parent} */}
          {/* {props} */}
          {leftIcon && leftIcon}
          {label && label}
          {children && children}
          {rightIcon && rightIcon}
        </button>
      </>
    );
  }
);

Button.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  customStyle: PropTypes.object,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  onClick: undefined,
  customStyle: {},
};
